/**
 * Chart State Components — copied from original
 * No Next.js-specific changes needed
 */

import { type ReactNode } from "react";

interface ChartStateProps {
  height: number;
  message?: string;
  title?: string;
  description?: string;
  icon?: string;
  onRetry?: () => void;
}

export function ChartLoading({ height }: ChartStateProps) {
  return (
    <div
      className="animate-pulse rounded-md bg-bg-elevated"
      style={{ height }}
      aria-label="Loading chart data"
      role="status"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
}

export function ChartError({ height, message, onRetry }: ChartStateProps) {
  return (
    <div
      className="flex flex-col items-center justify-center rounded-md border border-error-500/30 bg-error-500/5"
      style={{ height }}
      role="alert"
    >
      <p className="text-sm text-error-500 mb-2">
        {message || "Failed to load chart data"}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="text-xs text-error-400 hover:text-error-300 underline"
        >
          Retry
        </button>
      )}
    </div>
  );
}

export function ChartEmpty({
  height,
  title,
  description,
  icon,
}: ChartStateProps) {
  return (
    <div
      className="flex flex-col items-center justify-center rounded-md border border-border-default bg-bg-elevated/50"
      style={{ height }}
    >
      {icon && (
        <span className="text-3xl mb-2" aria-hidden="true">
          {icon}
        </span>
      )}
      <p className="text-sm font-medium text-text-secondary">
        {title || "No data available"}
      </p>
      {description && (
        <p className="text-xs text-text-tertiary mt-1">{description}</p>
      )}
    </div>
  );
}

export function ResponsiveChartContainer({
  children,
  title,
  height,
}: {
  children: ReactNode;
  title: string;
  height: number;
}) {
  return (
    <div role="img" aria-label={title} style={{ height }}>
      {children}
    </div>
  );
}
